import { ImageProcessingError, type ImageProcessingErrorCode } from './imageProcessor';

export type UploadFailureStage = 'image_processing' | 'upload_url' | 'storage_put' | 'verify';

export type MediaUploadFailureReason =
  | 'unsupported_mime_type'
  | 'file_too_large'
  | 'image_too_small'
  | 'invalid_image'
  | 'image_processing_failed'
  | 'timeout'
  | 'network_unavailable'
  | 'upload_url_failed'
  | 'storage_put_failed'
  | 'verify_failed'
  | 'unknown';

const IMAGE_ERROR_REASON_MAP: Record<ImageProcessingErrorCode, MediaUploadFailureReason> = {
  UNSUPPORTED_MIME_TYPE: 'unsupported_mime_type',
  FILE_TOO_LARGE: 'file_too_large',
  IMAGE_TOO_SMALL: 'image_too_small',
  INVALID_IMAGE: 'invalid_image',
  IMAGE_PROCESSING_FAILED: 'image_processing_failed',
};

export function normalizeMediaUploadFailureReason(
  error: unknown,
  stage: UploadFailureStage,
): MediaUploadFailureReason {
  if (error instanceof ImageProcessingError) {
    return IMAGE_ERROR_REASON_MAP[error.code];
  }

  if (error instanceof DOMException && error.name === 'AbortError') {
    return 'timeout';
  }

  if (error instanceof Error && error.name === 'AbortError') {
    return 'timeout';
  }

  if (error instanceof TypeError) {
    return 'network_unavailable';
  }

  if (stage === 'upload_url') return 'upload_url_failed';
  if (stage === 'storage_put') return 'storage_put_failed';
  if (stage === 'verify') return 'verify_failed';
  return 'unknown';
}
